import { PROJECT_NAMESPACE } from 'common';

export const NAMESPACE = `${PROJECT_NAMESPACE}/Search`;
export const SET_FILTERED_RESULTS_COUNT = `${NAMESPACE}/SET_FILTERED_RESULTS_COUNT`;



// WEBPACK FOOTER //
// ./src/containers/Search/constants.js